import script from "./SecurityContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityContainer.vue?vue&type=script&setup=true&lang=js"

import "./SecurityContainer.vue?vue&type=style&index=0&id=0666d782&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0666d782"]])

export default __exports__